import Loader from "@/atoms-react/loader/Loader.react";
import { Base, SectionTitle } from "@/atoms-react/text/Text.react";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { companyDetails } from "@/features/company/types";
import { UserType } from "@/features/user/types";
import { getFullName } from "@/features/utils/functions";
import { useTranslation } from "react-i18next";

type PublicVisibilityTitleSectionProps = {
  user?: UserType;
  companyDetails?: companyDetails | null;
  isCompanyDetailsLoading: boolean;
};

export const PublicVisibilityTitleSection = (props: PublicVisibilityTitleSectionProps) => {
  const { user, companyDetails, isCompanyDetailsLoading } = props;
  const { leUuid } = useCompanyContext();
  const { t } = useTranslation(["pass"]);

  const displayOnLoad = (isLoading: boolean, str: string, loaderStyle?: string) => {
    return <>{isLoading ? <Loader className={loaderStyle} /> : str}</>;
  };

  const ProPublicVisibility = () => {
    return (
      <div>
        <SectionTitle className="mb-1 text-white">
          {displayOnLoad(isCompanyDetailsLoading, companyDetails?.legalEntity.LegalName ?? "")}
        </SectionTitle>
        <Base className="-mb-1 text-white/70 md:mr-2 md:-mb-0">
          {t("olkypass.accountPage.profileSection.label.kyc_identifier")} :
          {displayOnLoad(
            isCompanyDetailsLoading,
            companyDetails?.legalEntity.identityUuid ?? "",
            "ml-5"
          )}
        </Base>
      </div>
    );
  };

  const ConsoPublicVisibility = () => {
    return (
      <div>
        <SectionTitle className="mb-1 text-white">
          {getFullName(user?.naturalPerson ?? { FirstName: "", LastName: "" })}
        </SectionTitle>
        <Base className="-mb-1 text-white/70 md:mr-2 md:-mb-0">
          {t("olkypass.accountPage.profileSection.label.kyc_identifier")} :
          {user?.naturalPerson.UUID}
        </Base>
      </div>
    );
  };

  return <div>{leUuid ? <ProPublicVisibility /> : <ConsoPublicVisibility />}</div>;
};
